import Vue from "vue";
import col from "element-ui/packages/col/src/col";

function formatDate(date, fmt) {
  if (date) {
    if (typeof date == "string") {
      date = new Date(date);
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (let k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return fmt;
  }
  return "";
}

function isNumberString(str) {
  let re = /^[0-9]+.?[0-9]*$/;
  return re.test(str);
}

/**
 * 加法
 * @param a
 * @param b
 */
function add(a, b) {
  let c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return (
    (e = Math.pow(10, Math.max(c, d))), (multiply(a, e) + multiply(b, e)) / e
  );
}

/**
 * 减
 * @param a 被减数
 * @param b 减数
 */
function subtract(a, b) {
  let c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return (
    (e = Math.pow(10, Math.max(c, d))), (multiply(a, e) - multiply(b, e)) / e
  );
}

/**
 * 乘
 * @param a
 * @param b
 * @returns {number}
 */
function multiply(a, b) {
  let c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split(".")[1].length;
  } catch (f) {}
  try {
    c += e.split(".")[1].length;
  } catch (f) {}
  return (
    (Number(d.replace(".", "")) * Number(e.replace(".", ""))) / Math.pow(10, c)
  );
}

/**
 * 除
 * @param a 被除数
 * @param b 除数
 */
function divide(a, b) {
  let c,
    d,
    e = 0,
    f = 0;
  try {
    e = a.toString().split(".")[1].length;
  } catch (g) {}
  try {
    f = b.toString().split(".")[1].length;
  } catch (g) {}
  return (
    (c = Number(a.toString().replace(".", ""))),
    (d = Number(b.toString().replace(".", ""))),
    multiply(c / d, Math.pow(10, f - e))
  );
}

function getUUID() {
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now();
  }
  let uuid = "xxxxxxxxxxxxxxxyxxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

function getId(func) {
  Vue.prototype.$get("/mes/system/base/query/id", {}, function(json) {
    func.call(Vue, json.id);
  });
}

function adjustFilterColumn(localStorageKey, columns) {
  let adjustColumns = JSON.parse(JSON.stringify(columns));
  let config;
  if (localStorage.getItem(localStorageKey)) {
    config = JSON.parse(localStorage.getItem(localStorageKey));
  } else {
    config = {};
  }
  for (let i = 0; i < adjustColumns.length; i++) {
    let column = adjustColumns[i];
    let columnConfig = config[column.column_field] || {};
    column.align = columnConfig["align"] || "center";
    column.column_width = columnConfig.column_width || column.column_width;
    column.is_grid_show = columnConfig["is_grid_show"] == 0 ? 0 : 1;
    column.column_order =
      columnConfig.column_order || column.column_order || i + 1;
  }
  let realColumnList = [];
  // 重新调整顺序
  for (let i = 0; i < adjustColumns.length; i++) {
    let column = adjustColumns[i];
    let index = column.column_order - 1;
    while (realColumnList[index]) {
      ++index;
    }
    column.column_order = index + 1;
    realColumnList[index] = column;
  }
  // 去除空位
  let returnList = [];
  let index = 1;
  for (let i = 0; i < realColumnList.length; i++) {
    let column = realColumnList[i];
    if (column) {
      column.column_order = index;
      returnList[index - 1] = column;
      index++;
    }
  }
  return returnList;
}

// vue防抖
function debounce(func, wait, immediate, context) {
  let timeout;
  return function(...args) {
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过,不再执行
      let callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
}
//  记录表保存
function recordSave(id = 0, json_obj) {
  let recordList = JSON.parse(localStorage.getItem("recordList")) || [];
  console.log(recordList);
  let flage = false;
  recordList.forEach((item, index) => {
    if (item.id == id) {
      item.json_obj = json_obj;
      flage = true;
    }
  });
  if (!flage) recordList.push({ id: id, json_obj: json_obj });
  localStorage.setItem("recordList", JSON.stringify(recordList));
  return recordList;
}

//  获取记录表
function getRecord(id = 0) {
  let recordList = JSON.parse(localStorage.getItem("recordList")) || [];
  let recordData = {};
  recordList.forEach((item, index) => {
    if (item.id == id) {
      recordData = item;
    }
  });
  return recordData;
}
// 删除记录表
function deleteRecord(id = 0) {
  let recordList = JSON.parse(localStorage.getItem("recordList")) || [];
  let recordData = {};
  recordList.forEach((item, index) => {
    if (item.id == id) {
      recordList.splice(index, 1);
    }
  });
  localStorage.setItem("recordList", JSON.stringify(recordList));
  return recordData;
}

export default {
  formatDate,
  isNumberString,
  add,
  subtract,
  multiply,
  divide,
  getUUID,
  getId,
  adjustFilterColumn,
  debounce,
  recordSave,
  getRecord,
  deleteRecord
};



// WEBPACK FOOTER //
// ./src/common/CommonUtils.js